import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { WarehouseGoodType } from '@web/features/warehouse';

@jsonObject
export class AdminWarehouseGoodConnectedObjectResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly type!: WarehouseGoodType;

  @jsonMember(String)
  public readonly name!: string;
}
